module.exports = __webpack_public_path__ + "img/S_Sparklet.f04410fc.png";